module.exports = __webpack_public_path__ + "img/home-delivery.f3bd50ac.svg";